export default "__VITE_ASSET__CKm7TDix__"